((app, ng) => {

    app.component("planningNotesButton",
        {
            template: `
                <md-button ng-click="$ctrl.openPlanningNotes($ctrl.caseid, $ctrl.user, $event)" class="md-icon-button btn-accent">
                    <md-icon md-font-icon="mdi mdi-24px mdi-message-bulleted" aria-label="View Notes"></md-icon>
                    <md-tooltip md-delay="500">View and Edit Case Notes</md-tooltip>
                </md-button>
            `,
            controller: caseNotesButtonController,
            bindings: {
                caseid: "<",
                user: "<"
            }
        });

    function caseNotesButtonController(caseModalService) {
        const $ctrl = this;

        const openPlanningNotes = (caseId, currentUser, $event) => {
            caseModalService.openPlanningNotes(caseId, currentUser, $event);
        }

        ng.extend($ctrl,
            {
                openPlanningNotes
            });
    }

})(window.app, window.angular);